import React from 'react';
import { Button, Modal } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const { confirm } = Modal;

const DeleteButton = ({ label, onOk, title, content, showIcon, ...props }) => {
  const showConfirm = () => {
    confirm({
      title,
      icon: <ExclamationCircleOutlined />,
      content,
      onOk,
    });
  };

  return (
    <Button danger type="primary" onClick={showConfirm} {...props}>
      {showIcon && <DeleteOutlined />}
      {label}
    </Button>
  );
};

DeleteButton.defaultProps = {
  label: 'Delete',
  title: 'Confrim to Delete?',
  content: `Do you want to delete this?`,
  showIcon: true,
};

DeleteButton.propTypes = {
  label: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  showIcon: PropTypes.bool.isRequired,
};

export default DeleteButton;
